export enum HMSQualityLimitationReason {
  BANDWIDTH = 'BANDWIDTH',
  CPU = 'CPU',
  NONE = 'NONE',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}
